(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alohas-header-legacy"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    const profileButton = document.querySelector('.ff-account-login-open');
    const cartButton = document.querySelector('.header__icon--cart');

    document.addEventListener('click', function(e) {
      if(e.target.closest('.ff-header-wishlist-icon')) {
        clarity("set", "navbar-click", "wishlist");
      }
    })
    
    profileButton?.addEventListener('click', function() {
      clarity("set", "navbar-click", "profile");
    })
    
    cartButton.addEventListener('click', function() {
      clarity("set", "navbar-click", "cart");
      
      /** DATA LAYER VIEW CART **/
      sendViewCartEvent();
    })
  });

  /** DATA LAYER VIEW CART FUNCTION **/
  function sendViewCartEvent() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        if (cartData.items && cartData.items.length > 0) {
          var dataLayer = window.dataLayer || [];
          
          const items = cartData.items.map((item, index) => {
            // Usar datos pre-renderizados por Liquid (evita depender de /cart.js para tags/metafields)
            const tagData = window.cartItemsTagData?.[String(item.variant_id)] || {};

            const getTag = (key, fallback) => {
              const val = tagData[key];
              if (val && val !== 'none') return val;
              // Fallback: buscar en window.alohasData si el usuario añadio el item tras cargar la pagina
              const product = window.alohasData?.findProductByHandle?.(item.handle);
              if (product && product.tags && Array.isArray(product.tags)) {
                const prefix = {
                  brand: 'brand:', subcategory1: 'subcategory1:', subcategory2: 'subcategory2:',
                  priced: 'priced:', web: 'web:', product_cluster: 'product_cluster:', delivery_g: 'delivery_g:',
                  style_av: 'style_av:', productse: 'productse:', style: 'style:', product_status: 'status:'
                }[key];
                if (prefix) {
                  const found = product.tags.find(t => t.startsWith(prefix));
                  if (found) return found.replace(prefix, '') || fallback;
                }
              }
              return fallback;
            };

            return window.cleanDataLayerParams({
              item_id: item.sku.toString(),
              item_name: window.alohasData.capitalizeEachWord(item.handle),
              coupon: "none",
              index: index + 1,
              item_category: window.alohasData.capitalizeEachWord(getTag('subcategory1', 'none')),
              item_category2: getTag('subcategory2', 'none'),
              item_list_name: getTag('subcategory1', 'none'),
              item_variant: item.variant_title || "none",
              price: parseFloat((item.price / 100).toFixed(2)),
              quantity: item.quantity,
              product_priced: getTag('priced', 'none'),
              product_drop: getTag('web', 'none'),
              product_cluster: getTag('product_cluster', 'none'),
              product_delivery_g: getTag('delivery_g', 'none'),
              product_status: getTag('product_status', 'none'),
              product_availability: getTag('style_av', 'none'),
              product_season: getTag('productse', 'none'),
              item_category4: getTag('style', 'none'),
              variant_availability: tagData.variant_availability || window.alohasData?.findVariantById?.(item.variant_id)?.variant_availability || 'none',
              variant_delivery: tagData.variant_delivery || window.alohasData?.findVariantById?.(item.variant_id)?.variant_delivery || 'none',
              variant_id: item.variant_id ? String(item.variant_id) : 'none',
              product_id: item.product_id ? String(item.product_id) : 'none'
            });
          });

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "view_cart",
            ecommerce: {
              currency: cartData.currency,
              value: parseFloat((cartData.total_price / 100).toFixed(2)),
              items: items
            }
          });
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
        this.classList.contains("ff-initial-bg-header") && this.classList.remove("ff-initial-bg-header");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
        this.classList.contains("ff-initial-bg-header") && this.classList.remove("ff-initial-bg-header");
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.classList.add("ff-initial-bg-header");
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alohas-header"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', function() {
    const profileButton = document.querySelector('.ff-account-login-open');
    const cartButton = document.querySelector('.header__icon--cart');

    document.addEventListener('click', function(e) {
      if(e.target.closest('.ff-header-wishlist-icon')) {
        clarity("set", "navbar-click", "wishlist");
      }
    })
    
    profileButton?.addEventListener('click', function() {
      clarity("set", "navbar-click", "profile");
    })
    
    cartButton.addEventListener('click', function() {
      clarity("set", "navbar-click", "cart");
      
      /** DATA LAYER VIEW CART **/
      sendViewCartEvent();
    })
  });

  /** DATA LAYER VIEW CART FUNCTION **/
  function sendViewCartEvent() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartData => {
        if (cartData.items && cartData.items.length > 0) {
          var dataLayer = window.dataLayer || [];
          
          const items = cartData.items.map((item, index) => {
            // Usar datos pre-renderizados por Liquid (evita depender de /cart.js para tags/metafields)
            const tagData = window.cartItemsTagData?.[String(item.variant_id)] || {};

            const getTag = (key, fallback) => {
              const val = tagData[key];
              if (val && val !== 'none') return val;
              // Fallback: buscar en window.alohasData si el usuario añadio el item tras cargar la pagina
              const product = window.alohasData?.findProductByHandle?.(item.handle);
              if (product && product.tags && Array.isArray(product.tags)) {
                const prefix = {
                  brand: 'brand:', subcategory1: 'subcategory1:', subcategory2: 'subcategory2:',
                  priced: 'priced:', web: 'web:', product_cluster: 'product_cluster:', delivery_g: 'delivery_g:',
                  style_av: 'style_av:', productse: 'productse:', style: 'style:', product_status: 'status:'
                }[key];
                if (prefix) {
                  const found = product.tags.find(t => t.startsWith(prefix));
                  if (found) return found.replace(prefix, '') || fallback;
                }
              }
              return fallback;
            };

            return window.cleanDataLayerParams({
              item_id: item.sku.toString(),
              item_name: window.alohasData.capitalizeEachWord(item.handle),
              coupon: "none",
              index: index + 1,
              item_category: window.alohasData.capitalizeEachWord(getTag('subcategory1', 'none')),
              item_category2: getTag('subcategory2', 'none'),
              item_list_name: getTag('subcategory1', 'none'),
              item_variant: item.variant_title || "none",
              price: parseFloat((item.price / 100).toFixed(2)),
              quantity: item.quantity,
              product_priced: getTag('priced', 'none'),
              product_drop: getTag('web', 'none'),
              product_cluster: getTag('product_cluster', 'none'),
              product_delivery_g: getTag('delivery_g', 'none'),
              product_status: getTag('product_status', 'none'),
              product_availability: getTag('style_av', 'none'),
              product_season: getTag('productse', 'none'),
              item_category4: getTag('style', 'none'),
              variant_availability: tagData.variant_availability || window.alohasData?.findVariantById?.(item.variant_id)?.variant_availability || 'none',
              variant_delivery: tagData.variant_delivery || window.alohasData?.findVariantById?.(item.variant_id)?.variant_delivery || 'none',
              variant_id: item.variant_id ? String(item.variant_id) : 'none',
              product_id: item.product_id ? String(item.product_id) : 'none'
            });
          });

          dataLayer.push({ ecommerce: null });
          dataLayer.push({
            event: "view_cart",
            ecommerce: {
              currency: cartData.currency,
              value: parseFloat((cartData.total_price / 100).toFixed(2)),
              items: items
            }
          });
        }
      })
      .catch(error => {
        console.error('Error fetching cart data:', error);
      });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
        this.classList.contains("ff-initial-bg-header") && this.classList.remove("ff-initial-bg-header");
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
        this.classList.contains("ff-initial-bg-header") && this.classList.remove("ff-initial-bg-header");
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.classList.add("ff-initial-bg-header");
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
